import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { ClipboardList } from "lucide-react";

export const GuardPostOrders = () => {
  const [orders, setOrders] = useState([]);
  const [sites, setSites] = useState([]);

  const load = useCallback(async () => {
    const [o, s] = await Promise.all([api.get("/post-orders"), api.get("/sites")]);
    setOrders(o.data);
    setSites(s.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const siteName = (id) => sites.find(s => s.id === id)?.name || "—";

  return (
    <div className="space-y-3">
      {orders.map(o => (
        <div key={o.id} className="s-card" data-testid={`gpo-${o.id}`}>
          <div className="flex items-start gap-3">
            <ClipboardList size={18} color="#2ECAC8" />
            <div className="flex-1">
              <div style={{ fontSize: 15, color: "#fff" }}>{o.title}</div>
              <div className="text-muted" style={{ fontSize: 12, marginTop: 2 }}>{siteName(o.site_id)}</div>
              <div style={{ fontSize: 13, color: "#fff", lineHeight: 1.6, marginTop: 10 }}>{o.body}</div>
            </div>
          </div>
        </div>
      ))}
      {orders.length === 0 && <div className="text-muted text-center" style={{ fontSize: 13 }}>No post orders yet.</div>}
    </div>
  );
};
